import { AHSeparator, Box, useBoxStyle, useLayoutContext } from "arkh";
import React, { useCallback } from "react";
import { SectionList, SectionListData } from "react-native";
import { WACategoryListItem } from "./WACategoryListItem";
import { WACategoryType } from "./Categories/WACategoryType";
import { useListContentStyle } from "../../../../components/mobile/useListContentStyle";

const ItemSeparatorComponent = () => <AHSeparator />;
export function WidgetAddMasterComponent<T extends string>(props: {
  selected?: T;
  chevron?: boolean;
  onPressIn?(key: T): void;
  onPress(key: T): void;
  sections: {
    data: WACategoryType<T>[];
  }[];
  type?: "card" | "fullsize";
}) {
  const renderItem = useCallback(
    ({
      item,
      index,
      section,
    }: {
      item: WACategoryType<T>;
      index: number;
      section: SectionListData<
        WACategoryType<T>,
        {
          data: WACategoryType<T>[];
        }
      >;
    }) => {
      return (
        <WACategoryListItem
          isFirst={props.type === "fullsize" ? false : index === 0}
          isLast={
            props.type === "fullsize"
              ? false
              : index === section.data.length - 1
          }
          chevron={props.chevron}
          category={item}
          selected={props.selected === item.key}
          onPressIn={() => props.onPressIn?.(item.key)}
          onPress={() => props.onPress(item.key)}
        />
      );
    },
    [props]
  );

  const contentContainerStyle = useListContentStyle();
  const layout = useLayoutContext();

  const renderSectionFooter = useCallback(() => <Box spaceTop="large" />, []);

  const style = useBoxStyle({
    color: props.type === "fullsize" ? "surface-primary" : "surface-background",
  });

  return (
    <SectionList
      sections={props.sections}
      keyExtractor={(item) => item.key}
      style={style}
      contentContainerStyle={
        props.type === "fullsize"
          ? {
              paddingVertical: layout.space.medium,
            }
          : contentContainerStyle
      }
      renderSectionFooter={renderSectionFooter}
      renderItem={renderItem}
      ItemSeparatorComponent={
        props.type === "fullsize" ? undefined : ItemSeparatorComponent
      }
    />
  );
}
